import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { CollaboratorsBadge } from './CollaboratorsBadge';

import styles from './CollaboratorsHeading.less';

interface CollaboratorsHeadingProps {
  collaboratorCount: number;
  workspaceId: string;
  isWorkspaceFree?: boolean;
}

export const CollaboratorsHeading: FunctionComponent<
  CollaboratorsHeadingProps
> = ({ collaboratorCount, workspaceId, isWorkspaceFree }) => {
  if (isWorkspaceFree) {
    return (
      <h2 className={styles.collaboratorsHeading}>
        <FormattedMessage
          id="templates.org_members.collaborators-heading"
          defaultMessage="Collaborators"
          description="Collaborators"
        />
        <CollaboratorsBadge
          collaboratorCount={collaboratorCount}
          workspaceId={workspaceId}
        />
      </h2>
    );
  }
  return (
    <h2 className={styles.collaboratorsHeading}>
      <FormattedMessage
        id="templates.org_members.collaborators"
        defaultMessage="Collaborators ({count})"
        description="Collaborators with a count"
        values={{
          count: collaboratorCount,
        }}
      />
    </h2>
  );
};
